import type { CommonPlugin } from "zudoku";

declare global {
  interface Window {
    UnoChatWidget?: {
      mount: (container: HTMLElement, options?: { locale?: string }) => Promise<() => void>;
    };
  }
}

const LOADER_SRC = "/uno-chat-loader.js";

const loadScript = (src: string) =>
  new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`uno-chat-plugin: failed to load ${src}`));
    document.head.appendChild(script);
  });

export const unoChatPlugin = (): CommonPlugin => {
  return {
    initialize: async () => {
      if (typeof window === "undefined") {
        return true;
      }

      await loadScript(LOADER_SRC);

      const container = document.createElement("div");
      container.id = "uno-chat-widget";
      document.body.appendChild(container);

      await window.UnoChatWidget?.mount(container, { locale: "ru-RU" });

      return true;
    },
  };
};
